import type { MenuProps } from './Menu'
import Menu from './Menu'

export type { MenuProps }
export default Menu
